import { useLocalization } from '@ais-ui/locale-management';
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@ais-ui/ui-core';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { cn } from '@ais-ui/utils';
import { ShapeSelect } from '../../Shapes/ShapeSelects/ShapeSelect';
import { MessagesFormValues } from './useMessagesForm';

interface MessageFormProps {
  form: UseFormReturn<MessagesFormValues>;
}

export const MessageForm = ({ form }: MessageFormProps) => {
  const { messages } = useLocalization();

  return (
    <Form {...form}>
      <div className="space-y-4">
        <FormField
          key="lookback_time_in_hours"
          control={form.control}
          name="lookback_time_in_hours"
          render={({ field }) => (
            <FormItem
              className={cn(
                'flex flex-row items-center justify-between border rounded-lg p-4'
              )}
            >
              <div className="space-y-0.5">
                <FormLabel className="text-base">
                  {messages.settingsMessageLookbackLabel}
                </FormLabel>
                <FormDescription>
                  {messages.settingsMessageLookbackDescription}{' '}
                </FormDescription>
              </div>
              <FormControl
                id="settings-message-lookback"
                onChange={() => form.clearErrors()}
              >
                <Input
                  className="w-20"
                  type="number"
                  {...field}
                  onChange={(e) => {
                    if (!e.target.value) {
                      field.onChange('');
                    } else {
                      // Convert the string value to a number
                      const numberValue = parseFloat(e.target.value);
                      field.onChange(numberValue);
                    }
                  }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          key="message_shape"
          control={form.control}
          name="message_shape"
          render={({ field }) => (
            <FormItem
              className={cn(
                'flex flex-row items-center justify-between border rounded-lg p-4'
              )}
            >
              <div className="space-y-0.5">
                <FormLabel className="text-base">
                  {messages.settingsMessageShapeLabel}
                </FormLabel>
                <FormDescription>
                  {messages.settingsMessageShapeDescription}
                </FormDescription>
              </div>
              <FormControl
                id="settings-message-shape"
                onChange={() => form.clearErrors()}
              >
                <ShapeSelect
                  className="w-72"
                  id="message-shape-select"
                  value={field.value}
                  onChange={field.onChange}
                  allowedGeometryTypes={['Polygon']}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </Form>
  );
};
